<template>
    <div>
        <h1 class="display-heading">Credit Balance</h1>

        <div class="card mb-5">
            <div class="card-body">
                <h5 class="card-title">My Credit Balance</h5>
                <div class="ewallet-display">RM {{walletAmount.toFixed(2)}}</div>
                <p class="card-text">Payment amount of refunded sales will be credited into your credit balance.</p>
            </div>
        </div>

        <div ref="tableSection">
            <h5 class="mb-3">Credit Balance History</h5>

            <div class="d-md-none">
                <div class="card mb-3" v-if="historyList.length === 0">
                    <div class="card-body">
                        {{isTableLoading ? "Loading Data": "No Data"}}
                    </div>
                </div>

                <div class="card mb-3" v-for="(historyItem, index) in historyList" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Action Date
                            </label>
                            <div>
                                {{historyItem.date}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Amount (RM)
                            </label>
                            <div>
                                {{historyItem.amount}}
                            </div>
                        </div>
                        <div>
                            <label class="label-display">
                                Remarks
                            </label>
                            <div>
                                {{historyItem.remarks}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="40">
                        <col width="200">
                        <col width="140">
                        <col>
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Action Date</th>
                            <th scope="col" class="text-right">Amount (RM)</th>
                            <th scope="col">Remarks</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="historyList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(historyItem, index) in historyList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td class="text-nowrap">{{historyItem.date}}</td>
                            <td class="text-nowrap text-right">
                                {{historyItem.amount}}
                            </td>
                            <td class="text-nowrap">
                                {{historyItem.remarks}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination';
import {
    convertToUserReadableDateTime
} from '@/utilities';
export default {
    'name': 'UserWallet',
    'components': {
        pagination
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;
        this.getMyWallet();
        this.getWalletLog();

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getWalletLog();
            });
        }
    },
    data () {
        return {
            'walletAmount': 0,
            'historyList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            }
        };
    },
    'methods': {
        getMyWallet () {
            this.axios.get('Wallet/GetMyWallet').then(({
                data
            }) => {
                if (data.data) {
                    this.walletAmount = data.data.a;
                }
            });
        },
        getWalletLog () {
            this.axios.post('Wallet/GetHistory', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;
                this.historyList = list.map((item) => ({
                    'amount': `${item.a.toFixed(2)}`,
                    'date': item.d ? convertToUserReadableDateTime(item.d) : '-',
                    'remarks': item.r ? item.r : '-'
                }));
            });
        }
    }
};

</script>

<style>
    .ewallet-display:not(:last-child) {
        padding: 0 0 1.25rem;
    }

    .ewallet-display {
        font-size: 2.5rem;
        font-weight: 300;
    }

</style>
